import { render, staticRenderFns } from "./AwardUpFile.vue?vue&type=template&id=58e4039f&scoped=true"
import script from "./AwardUpFile.vue?vue&type=script&lang=js"
export * from "./AwardUpFile.vue?vue&type=script&lang=js"
import style0 from "./AwardUpFile.vue?vue&type=style&index=0&id=58e4039f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e4039f",
  null
  
)

export default component.exports